import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";
import axios from "axios";
import {BASE_URL} from "../Apis/apiConfig";


const MemberCreditNote = () => {
  const location = useLocation();
  const rawData = location.state?.record?.[0] || {};
  const pdfRef = useRef();
  const society = localStorage.getItem("society");
  const societyRegNo = localStorage.getItem("societyRegNo");

  // use lowercase 'rows' to match usage below
  const [rows, setRows] = useState([]);

  // added states & config used in your fetch effect
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 
  const token = localStorage.getItem("token") || "";

  useEffect(() => {
    if (!society || !String(society).trim()) {
      setRows([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const url = `${BASE_URL}/api/get-society-by-admin?societyName=${encodeURIComponent(
          society
        )}&registrationNo=${encodeURIComponent(societyRegNo)}`;

        const response = await axios.get(url, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });

        setRows(Array.isArray(response.data) ? response.data : []);
        console.log("Bill data", response.data);
      } catch (err) {
        console.error(err);
        setRows([]);
        setError(err?.response?.data || err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [society, societyRegNo, token]);

  const firstRow = rows && rows.length > 0 ? rows[0] : null;

  const addressParts = firstRow
    ? [
        firstRow.society_address,
        firstRow.society_address2,
        firstRow.society_address3,
        firstRow.society_area,
      ].filter(Boolean)
    : [];

  const addressString = firstRow
    ? (addressParts.join(", ") || "") + (firstRow.pin_code ? ` - ${firstRow.pin_code}` : "")
    : "";

  const phoneString = firstRow
    ? firstRow.contact_person_phone_no?.trim() || firstRow.contact_person?.trim() || ""
    : "";

  const formatAmount = (amount) => Number(amount || 0).toFixed(2);

  const downloadPDF = () => {
    const element = pdfRef.current;
    const options = {
      margin: 0.2,
      filename: `DebitNote_${rawData["Bill_No."] || "Document"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    if (!element) {
      console.warn("PDF element not found");
      return;
    }

    html2pdf().set(options).from(element).save();
  };

  const particulars = [
    { label: "Maintenance Charges", value: rawData["Maintenance_Charges"] },
    { label: "Water Charges", value: rawData["Water_Charges"] },
    { label: "Electricity Charges", value: rawData["Electricity_Chg."] },
    { label: "Insurance", value: rawData["Insurance"] },
    {
      label: "Repair Fund",
      value: rawData["Repair_Fund-_External_Repair_Only"],
    },
    { label: "Sinking Fund", value: rawData["Sinking_Fund"] },
    {
      label: "Parking Charges - 2 Wheeler",
      value: rawData["Parking_Charges_2_Wheeler"],
    },
  ];

  return (
    <div>
      <div style={{ textAlign: "center", margin: "30px 0" }}>
        <button
          onClick={downloadPDF}
          style={{
            padding: "10px 20px",
            backgroundColor: "#4CAF50",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Download PDF
        </button>
      </div>
      <div
        ref={pdfRef}
        style={{
          width: "800px",
          margin: "auto",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
          backgroundColor: "#fff",
          padding: "20px",
          border: "1px solid #000",
        }}
      >
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          <h2 style={{ margin: "5px 0" }}>{society}</h2>
          <div>Registration No.: {societyRegNo}</div>
          <div>{addressString} {phoneString}</div>
          <hr />
          <h3 style={{ marginTop: "10px" }}>Debit NOTE</h3>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <div>
            <strong>Voucher No :</strong> {rawData["Bill_No."] || "N/A"}
          </div>
          <div>
            <strong>Date :</strong> {rawData["Bill_Date"] || "N/A"}
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <table
            width="100%"
            cellPadding="10"
            style={{
              borderCollapse: "collapse",
              width: "100%",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#f0f0f0",
                  borderBottom: "2px solid #000",
                }}
              >
                <th style={{ textAlign: "left", border: "1px solid #ccc" }}>
                  Particulars
                </th>
                <th style={{ textAlign: "right", border: "1px solid #ccc" }}>
                  Dr Amount (₹)
                </th>
                <th style={{ textAlign: "right", border: "1px solid #ccc" }}>
                  Cr Amount (₹)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: "#fafafa" }}>
                <td style={{ border: "1px solid #ccc" }}>
                  {rawData["Member_Name"]}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    border: "1px solid #ccc",
                  }}
                >
                  {formatAmount(rawData["Total_Amount"])}
                </td>
                <td style={{ border: "1px solid #ccc" }}></td>
              </tr>
              {particulars.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                  }}
                >
                  <td style={{ border: "1px solid #ccc" }}>{item.label}</td>
                  <td style={{ border: "1px solid #ccc" }}></td>
                  <td
                    style={{
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    {formatAmount(item.value)}
                  </td>
                </tr>
              ))}
              <tr style={{ fontWeight: "bold", backgroundColor: "#eaeaea" }}>
                <td style={{ border: "1px solid #ccc" }}>Total</td>
                <td
                  style={{
                    textAlign: "right",
                    border: "1px solid #ccc",
                  }}
                >
                  {formatAmount(rawData["Total_Amount"])}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    border: "1px solid #ccc",
                  }}
                >
                  {formatAmount(rawData["Total_Amount"])}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          <div>( Rupees {formatAmount(rawData["Total_Amount"])} Only )</div>
          <div>
            <strong>Total :</strong> ₹ {formatAmount(rawData["Total_Amount"])} / ₹{" "}
            {formatAmount(rawData["Total_Amount"])}
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          <strong>
            For the month of {String(rawData["Bill_Date"] || "").split("-")[1] || ""}-25 as
            per instruction
          </strong>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "50px",
          }}
        >
          <div>
            <strong>Prepared by</strong>
          </div>
          <div>
            <strong>Authorised by</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberCreditNote;
